export const dashedSwatchStrokeDasharray = '4 2';

export function DashedLineSwatch({ color }: { color: string }) {
  return (
    <svg width="12" height="4" viewBox="0 0 12 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line
        x1="0"
        y1="2"
        x2="12"
        y2="2"
        stroke={color}
        strokeWidth="4"
        strokeDasharray={dashedSwatchStrokeDasharray}
      />
    </svg>
  );
}

export function dashedLineSwatchHtml(color: string): string {
  return (
    `<svg width="12" height="4" viewBox="0 0 12 4" fill="none" ` +
    `style="display:inline-block;flex-shrink:0" xmlns="http://www.w3.org/2000/svg">` +
    `<line x1="0" y1="2" x2="12" y2="2" stroke="${color}" stroke-width="4" stroke-dasharray="${dashedSwatchStrokeDasharray}" />` +
    `</svg>`
  );
}
